import TranslateIcon from '@mui/icons-material/Translate';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { supportedLanguages } from '../i18n';

export default function LanguageMenu() {
  const { t, i18n } = useTranslation();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  return (
    <>
      <Tooltip title={t('common.language')}>
        <IconButton onClick={(event) => setAnchor(event.currentTarget)} aria-label={t('common.language')}>
          <TranslateIcon />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchor} open={anchor !== null} onClose={() => setAnchor(null)}>
        {supportedLanguages.map((language) => (
          <MenuItem
            key={language.code}
            selected={i18n.language === language.code}
            onClick={() => {
              void i18n.changeLanguage(language.code);
              setAnchor(null);
            }}
          >
            {language.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
